export default __webpack_public_path__ + "static/media/mhb.be5e7bc8.png";